export enum RoleType {
    ORGANIZATION_OWNER = "organization-owner",
    OPERATION_MANAGER = "operation-manager",
    PROGRAM_MANAGER = "program-manager",
    PARTNER = "partner",
    CUSTOMER_SERVICE = "customer-service",
}
